import {
  Banking,
  BeneficiariesWidget,
  ExchangeRateWidget,
  MyFinances,
  TransactionHistory,
} from "@/modules/dashboard/components";
import { useAppSelector } from "@/shared/hooks";
import { useEffect } from "react";

export const DashboardPage = () => {
  const { toggles, isLoaded } = useAppSelector((state) => state.featureToggle);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="full-width flexbox justify-content--center page-container main-grid-wrapper">
      <div
        className="dashboard main-grid full-width h-fit-content mb-32">
        <div className="main-grid--left-widgets">
          <MyFinances/>
          <Banking/>
          <TransactionHistory/>
        </div>
        <div className="main-grid--right-widgets">
          <ExchangeRateWidget/>
          {isLoaded && toggles.isBeneficiaryAvailable && (
            <BeneficiariesWidget/>
          )}
        </div>
      </div>
    </div>
  );
};
